import React, { useState } from "react";

import { Auth } from "aws-amplify";

import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

// ✅ Remplacement de @mui/styles par @mui/material/styles
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    // backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  container: {
    margin: "0 auto",
    background: "#fcfcfc",
    maxWidth: 460,
    width: "100%",
    marginTop: 120,
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 0,
    padding: "10px 0",
  },
  error: {
    color: "red",
  },
}));

const AuthVerify = function (props) {
  const classes = useStyles();
  const { username, destination } = props;

  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState([]);

  const handleVerify = async () => {
    setError([]);
    setSubmitting(true);
    try {
      await Auth.confirmSignUp(username, code);
      window.location.href = "/login";
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      setError([error.message || error.code]);
    }
  };

  const onCodeChange = (e) => {
    setCode(e.target.value);
  };

  return (
    <div className={classes.root}>
      <Card className={classes.container}>
        <CardHeader
          className={classes.header}
          title="Validation du compte"
          // subheader={`Le code de vérification à été envoyé à l'adresse ${destination}.`}
        />
        <CardContent>
          <Typography>{`Le code de vérification à été envoyé à l'adresse ${destination}.`}</Typography>
          <form noValidate autoComplete="off" className={classes.root}>
            <FormControl fullWidth>
              <TextField
                label="code vérification"
                margin="normal"
                placeholder="Saisissez le code de vérification"
                onChange={onCodeChange}
                variant="outlined"
                value={code}
              />
            </FormControl>
          </form>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button
            variant="contained"
            disabled={submitting || code === ""}
            onClick={handleVerify}
          >
            {submitting ? "processing ..." : "Envoyer"}
          </Button>
        </CardActions>
        {error.length > 0
          ? error.map((e, key) => (
              <Typography className={classes.error} key={key}>
                {e}
              </Typography>
            ))
          : null}
      </Card>
    </div>
  );
};

export default AuthVerify;
